import { render, staticRenderFns } from "./ControlRoles.vue?vue&type=template&id=23fd5547&lang=pug"
import script from "./ControlRoles.vue?vue&type=script&lang=js"
export * from "./ControlRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports